import React from 'react'
import { Stack } from '@mui/material'

import DateFormat from '../../constants/dateFormat'
import i18nUiComponents from '../../locales/i18n'
import { Constant, QuestionPriorAnswer } from '../../types'
import { formatDate } from '../../utils/dateUtils'
import Text from '../Text'
import { getMultipleAnswerDisplayValue } from './questionUtils'

export interface PriorQuestionAnswersProps {
  readonly AnswerInputTypes: Constant[]
  readonly priorAnswers: QuestionPriorAnswer[]
}

const PriorQuestionAnswers = ({
  AnswerInputTypes,
  priorAnswers,
}: PriorQuestionAnswersProps) => (
  <Stack spacing={1}>
    <Text variant="lowAccent3">
      {i18nUiComponents.t<string>('Common:PRIOR_ANSWERS')}
    </Text>
    {priorAnswers?.map(({ id, inputs, text, timestamp }) => {
      const getPriorAnswerText = () => {
        if (inputs.length === 0) {
          return text
        }

        return getMultipleAnswerDisplayValue({ AnswerInputTypes, inputs, text })
      }

      return (
        <Stack direction="row" key={id} spacing={1.5}>
          {timestamp && (
            <Text lineHeight={1.2} variant="lowAccent2" width={75}>
              {formatDate(timestamp, false, DateFormat.SHORT_DATE_YEAR_ABBREV)}
            </Text>
          )}
          <Text lineHeight={1.2} variant="lowAccent2">
            {getPriorAnswerText()}
          </Text>
        </Stack>
      )
    })}
  </Stack>
)

export default PriorQuestionAnswers
